import _styled from "styled-components";
import React from "react";
import { ReactComponent as Plus } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/pluscirclewhite.svg";
import { ReactComponent as Minus } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/minuscirclewhite.svg";
import { useDeviceApi } from "../../DeviceData/useDeviceApi";

var Container = _styled.div.withConfig({
  displayName: "ManualControl__Container",
  componentId: "djvxcp-0"
})(["display:flex;justify-content:space-between;width:70%;margin:38px auto 0;@media screen and (max-width:419px){margin-top:20px;}"]);

var Button = _styled.button.withConfig({
  displayName: "ManualControl__Button",
  componentId: "djvxcp-1"
})(["padding:0;border:0 none;background:none transparent;opacity:0.5;&:enabled{cursor:pointer;opacity:1;}&:focus{outline:0 none;}svg{display:block;}"]);

export function ManualControl(_ref) {
  var onIncrement = _ref.onIncrement,
      onDecrement = _ref.onDecrement,
      _ref$incrementable = _ref.incrementable,
      incrementable = _ref$incrementable === void 0 ? true : _ref$incrementable,
      _ref$decrementable = _ref.decrementable,
      decrementable = _ref$decrementable === void 0 ? true : _ref$decrementable;
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Button, {
    onClick: onDecrement,
    disabled: !decrementable
  }, /*#__PURE__*/React.createElement(Minus, null)), /*#__PURE__*/React.createElement(Button, {
    onClick: onIncrement,
    disabled: !incrementable
  }, /*#__PURE__*/React.createElement(Plus, null)));
}